import { useQuery } from "@tanstack/react-query";
import { getBillingHistory } from "@lib/billing";
import { billingQueryKeys } from "./useBillingStatus";

export function useBillingHistory() {
    return useQuery({
        queryKey: billingQueryKeys.history(),
        queryFn: () => getBillingHistory(),
    });
}
